<template>
    <highcharts
        :options="options"
        :update-args="updateArgs"></highcharts>
</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
    name: "IncomeChart",

    components: {
        highcharts: Chart
    },

    props: {
        relativeYearMonthlyIncome: {
            type: Array,
            default: () => []
        },
        relativeYearMonthlyNeeds: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        options() {
            return {
                chart: {
                    defaultSeriesType: 'line',
                    height: 200,
                    backgroundColor: 'transparent',
                    plotBackgroundColor: 'transparent'
                },
                series: [{
                    type: 'area',
                    name: 'Monthly Income',
                    data: this.relativeYearMonthlyIncome
                }, {
                    name: 'Monthly Income needs (inflation)',
                    color: 'red',
                    data: this.relativeYearMonthlyNeeds
                }],
                title: {
                    text: '<i data-tooltip aria-haspopup="true" class="has-tip tip-top fa fa-question-circle inline"></i>Plan Income vs Needs<i data-tooltip aria-haspopup="true" class="has-tip tip-top fa fa-question-circle inline"></i>',
                    useHTML: true
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        stacking: 'normal'
                    },
                    series: {
                        marker: {
                            enabled: false
                        },
                        states: {
                            inactive: {
                                opacity: 1
                            }
                        }
                    }
                },
                yAxis: {
                    labels: {
                        enabled: false
                    },
                    gridLineColor: 'transparent',
                    min: 0,
                    title: {
                        text: 'Amount of money',
                        enabled: false
                    }
                },
                xAxis: {
                    gridLineColor: 'transparent',
                    title: {
                        text: 'Time'
                    }
                },
                navigator: {
                    enabled: false
                },
                scrollbar: {
                    enabled: false
                },
                rangeSelector: {
                    enabled: false
                },
                exporting: {
                    sourceWidth: 940,
                    buttons: {
                        contextButton: {
                            enabled: false
                        }
                    }
                }
            }
        }
    },

    data() {
        return {
            updateArgs: [true, true, {duration: 1000}]
        }
    },
}
</script>
